import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm sm:text-base"
}
const _hoisted_2 = {
  key: 0,
  class: "py-2 border-gray-200 border-b"
}
const _hoisted_3 = { class: "flex items-center justify-between px-4 py-2" }
const _hoisted_4 = { class: "font-semibold text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_5 = { class: "flex items-center justify-between px-4 py-2" }
const _hoisted_6 = { class: "font-semibold text-sm text-gray-500 whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layouts_auth_sidebar_content_menu = _resolveComponent("layouts-auth-sidebar-content-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (Array.isArray(_ctx.store.state.menu.menuCategories) && _ctx.store.state.menu.menuCategories.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.menu.menuCategories, (category) => {
              return (_openBlock(), _createElementBlock("li", {
                key: category.id
              }, [
                (Array.isArray(category.menus) && category.menus.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(category.name), 1)
                      ]),
                      _createVNode(_component_layouts_auth_sidebar_content_menu, {
                        menus: category.menus
                      }, null, 8, ["menus"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["py-2 border-gray-200 border-b cursor-pointer hover:bg-gray-200", ['/recommend' === _ctx.currentUrl ? 'bg-blue-200': '']]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.routeRecommend && _ctx.routeRecommend(...args)))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('recommend.title')), 1)
        ])
      ], 2)
    ])
  ], 64))
}